require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-your-new-go-to-barbershop.json") })
        }
      }, "path---news-your-new-go-to-barbershop");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-your-new-go-to-barbershop!./.cache/json/news-your-new-go-to-barbershop.json
// module id = 877
// module chunks = 231608221292675